import React from 'react';
import LayoutLanding from '../components/LandingLayout';

const Step0 =  ({setPage}) => {
    return (
        <LayoutLanding  setPage={setPage} />
    );
};

export default Step0;
